require('knacss/sass/knacss.scss');

import 'slick-slider/slick/slick.css';
import '../sass/app.scss';

import $ from 'jquery';
global.$ = global.jQuery = $;

import 'slick-slider';

require('./front/components/all');
require('./front/form/all');
require('./front/pages/all');
require('../../vendor/maier/front-common-bundle/Resources/assets/js/website/maier_main/base');

// Temporary from 2nd september (to remove 08th october 2025: useless)
let currentDate = new Date();
let iwcBoutiqueOpenDate = new Date('10/08/2025'); // 08th october
if (-1 === window.location.href.search('ab602ffd19922904e03dabe6ebc128de') && currentDate.getTime() < iwcBoutiqueOpenDate.getTime()) {
    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.maier-section-shops-list-item:nth-child(6)').forEach(function (section) {
            section.style.display = 'none';
        });
    })

    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.menu-maier-spirit ul li:nth-child(9)').forEach(function (section) {
            section.style.display = 'none';
        });
    })
}
